import React from 'react';
import { useHistory } from 'react-router-dom';
import { IconButton, Badge, Tooltip } from '@material-ui/core';
import { Notifications as NotificationsIcon } from '@material-ui/icons';
import { useQuery } from '@tanstack/react-query';

import { loadOpportunities } from '~/services/api';
import { OpportunityStatusRequest } from '~/types';

export function HeaderNotifications() {
  const history = useHistory();

  const { data } = useQuery(
    ['orders', OpportunityStatusRequest.MANUAL_ALLOCATION, 'header-badge'],
    () => loadOpportunities(OpportunityStatusRequest.MANUAL_ALLOCATION),
    {
      refetchInterval: 30 * 1000,
    },
  );

  const pendingCount = data?.data?.length ?? 0;

  const handleClick = () => {
    history.push('/opportunity-manager?tab=contra-proposta');
  };

  return (
    <IconButton
      color="inherit"
      aria-label="notificações de aceite"
      onClick={handleClick}
      style={{ position: 'relative', zIndex: 9999 }}
    >
      <Tooltip title={pendingCount > 0 ? `${pendingCount} atendimento(s) pendente(s) de aceite` : 'Notificações'}>
        <Badge badgeContent={pendingCount} color="secondary" invisible={pendingCount === 0}>
          <NotificationsIcon />
        </Badge>
      </Tooltip>
    </IconButton>
  );
}

export default HeaderNotifications;
